
























































import {
    getChecklist,
    getComponentTree,
    getComponent,
    getTask,
    getQuestion,
    getAnswer,
    updateItem,
} from "@/services/checklist.service";
import {
    translate,
} from "@/services/translate.service";
import LanguageSelector from "@/components/LanguageSelector.vue";

interface ComponentInfo {
    children: ComponentInfo[]
    id: string
    name: string
    parentId?: string
}

interface TaskInfo {
    text: string // name
    value: string // id
}

interface QuestionInfo {
    text: string // name
    value: string // id
}

interface AnswerInfo {
    text: string // name
    value: string // id
}

interface ProgressInfo {
    title: string
    name: string
    current: number
    total: number
    percent: number
}

export default {
    props: ['cl_item'],
    data() {
        return {
            na1: false,
            initLoaded: true,
            formValid: false,
            snackbar: false,
            translating: false,
            snackbar_text: "",
            sourceLocale: 'de',
            targetLocale: 'en',
            sourceLanguage: { name: 'German', locale: 'de' },
            targetLanguage: { name: 'English', locale: 'en' },
            translate_dialog: {},
            checklist: null,
            totalComponents: 0,
            languages: '',
            componentProgress: { title: 'COMPONENT', name: '', current: 0, total: 0, percent: 0 },
            taskProgress: { title: 'TASK', name: '', current: 0, total: 0, percent: 0 },
            questionProgress: { title: 'CHECKPOINT', name: '', current: 0, total: 0, percent: 0 },
            answerProgress: { title: 'RESULT', name: '', current: 0, total: 0, percent: 0 },
            progress: [],
            locale: '',
        };
    },
    async mounted() {
        console.log('mounted', this.cl_item, this.$store);
        this.$store.state.cl_uid = this.cl_item.uid;

        const respChecklist = await getChecklist(this.$store.state.lang, this.$store.state.cl_uid).catch((e) => {
            this.$store.dispatch("api_error", e);
        });

        this.progress = [
            this.componentProgress,
            this.taskProgress,
            this.questionProgress,
            this.answerProgress,
        ]

        if (respChecklist && respChecklist.status == "success") {
            if (respChecklist.data.checklist.length > 0) {
                this.checklist = respChecklist.data.checklist[0];
                console.log('checklist', this.checklist);
            }
        }
    },
    methods: {
        async translate() {
            console.log('translate', this.sourceLocale, this.targetLocale);
            await this.translateChecklist();
        },
        cancel() {
            console.log('cancel');
            this.translating = false;
        },
        closeDialog: function () {
            this.cancel();
            this.$emit("dialogClosed", true);
        },
        // recursive function to count components in a checklist
        async countComponent(componentInfo: ComponentInfo) {
            // console.log('countComponent', component.name, component.children);
            this.totalComponents++;
            if (componentInfo.children) {
                for (const c of componentInfo.children) {
                    await this.countComponent(c);
                };
            }
        },
        async translateItem(item: any, field: string = 'name'): Promise<boolean> {
            // console.log('translateItem', item, field);
            let changed = false;

            if (item && this.translating) {
                let sourceLocaleNameField = field;
                if (this.sourceLocale != 'de') {
                    sourceLocaleNameField += '_' + this.sourceLocale;
                }
                let targetLocaleNameField = field;
                if (this.targetLocale != 'de') {
                    targetLocaleNameField += '_' + this.targetLocale;
                }
                if (item[sourceLocaleNameField] && item[sourceLocaleNameField].length > 0 && (!item[targetLocaleNameField] || item[targetLocaleNameField].length == 0)) {
                    console.log('translateItem', item[sourceLocaleNameField], item, this.sourceLocale, this.targetLocale);
                    // simulate async IO
                    // await new Promise(resolve => setTimeout(resolve, 100));
                    const translation = await translate(item[sourceLocaleNameField], this.sourceLocale, this.targetLocale);
                    if (translation) {
                        item[targetLocaleNameField] = translation;
                        changed = true;
                    }
                }
            }
            return changed;
        },
        onsourceLocaleChanged(language: any) {
            this.sourceLocale = language.locale;
            console.log('onsourceLocaleChanged', this.sourceLocale);
        },
        ontargetLocaleChanged(language: any) {
            this.targetLocale = language.locale;
            console.log('ontargetLocaleChanged', this.targetLocale);
        },
        initProgress(progress: ProgressInfo, total: number) {
            progress.current = 0;
            progress.total = total;
        },
        progressNext(progress: ProgressInfo, name: string,) {
            progress.name = name;
            progress.current++;
            if (progress && progress.total) {
                progress.percent = 100 * progress.current / progress.total;
            }
        },
        async getComponentDataFromComponentInfo(componentInfo: ComponentInfo) {
            let componentData = null
            let sl = componentInfo.id.split('_');
            if (sl.length > 1) {
                const level = sl[0];
                const componentId = sl[1];

                const componentResponse = await getComponent(this.$store.state.cl_uid, componentId, level);
                console.log('componentResponse', componentResponse);
                if (componentResponse && componentResponse.status == 'success') {
                    componentData = componentResponse.data;
                }
            }
            return componentData;
        },
        async translateAnswers(answerList: AnswerInfo[]) {
            if (this.translating) {

                const progress = this.answerProgress;
                this.initProgress(progress, answerList.length)

                for (const a of answerList) {
                    this.progressNext(progress, a.text);

                    const answerResponse = await getAnswer(this.$store.state.cl_uid, a.value);
                    console.log('answerResponse', answerResponse);
                    if (answerResponse) {
                        let changed = false;
                        const answer = answerResponse.data.answer;
                        changed = changed || await this.translateItem(answer, 'name');
                        changed = changed || await this.translateItem(answer, 'result');
                        changed = changed || await this.translateItem(answer, 'recommendation');
                        if (changed) {
                            console.log('updateAnswer', answer);
                            answer.type = "answer";
                            await updateItem(answer);
                        }
                    }
                };
            }
        },
        async translateQuestions(questionInfoList: QuestionInfo[]) {
            if (this.translating) {

                const progress = this.questionProgress;
                this.initProgress(progress, questionInfoList.length)

                for (const q of questionInfoList) {
                    this.progressNext(progress, q.text);

                    const questionResponse = await getQuestion(this.$store.state.cl_uid, q.value);
                    console.log('questionResponse', questionResponse);
                    if (questionResponse) {
                        const question = questionResponse.data.question;
                        const answerList: AnswerInfo[] = questionResponse.data.details.answer_list;
                        let changed = false;
                        changed = changed || await this.translateItem(question, 'name');
                        changed = changed || await this.translateItem(question, 'format');
                        changed = changed || await this.translateItem(question, 'reportText');
                        if (changed) {
                            console.log('updateQuestion', question);
                            question.type = "question";
                            await updateItem(question);
                        }
                        if (answerList) {
                            await this.translateAnswers(answerList);
                        }
                    }
                }
            }
        },

        async translateTasks(componentInfo: ComponentInfo) {
            if (this.translating) {

                const componentData = await this.getComponentDataFromComponentInfo(componentInfo);
                if (componentData) {
                    const taskInfoList: TaskInfo[] = componentData.details.task_list;
                    if (taskInfoList) {
                        const progress = this.taskProgress;
                        this.initProgress(progress, taskInfoList.length)

                        for (const t of taskInfoList) {
                            // Update task progress
                            this.progressNext(progress, t.text);

                            const taskResponse = await getTask(this.$store.state.cl_uid, t.value);
                            console.log('taskResponse', taskResponse);
                            if (taskResponse && taskResponse.status == 'success') {
                                const task = taskResponse.data.task;
                                const questionList: QuestionInfo = taskResponse.data.details.question_list;
                                let changed = false;
                                changed = changed || await this.translateItem(task, 'name');
                                changed = changed || await this.translateItem(task, 'instruction');
                                changed = changed || await this.translateItem(task, 'reportText');
                                if (changed) {
                                    console.log('updateTask', task);
                                    task.type = 'task';
                                    await updateItem(task);
                                }

                                if (questionList) {
                                    await this.translateQuestions(questionList);
                                }
                            }
                        };
                    }
                }
            }
        },

        // recursive function to translate components in a checklist
        async translateComponent(componentInfo: ComponentInfo) {
            if (this.translating) {
                console.log('translateComponent', componentInfo);

                const progress = this.componentProgress;
                this.progressNext(progress, componentInfo.name);
                let changed = false;
                const componentData = await this.getComponentDataFromComponentInfo(componentInfo);
                const component = componentData.component;
                const level = componentData.level;
                console.log('component', component);
                changed = changed || await this.translateItem(component, 'name');
                changed = changed || await this.translateTasks(componentInfo);
                if (changed) {
                    console.log('updateComponent', component);
                    if (level > 1) {
                        component.type = "subcomponent";
                    } else {
                        component.type = "component";
                    }
                    await updateItem(component);
                }

                // Check if there are child components, translate recursively
                if (componentInfo.children) {
                    for (const c of componentInfo.children) {
                        await this.translateComponent(c);
                    };
                }
            }
        },

        async translateChecklist() {
            if (this.checklist) {
                this.translating = true;
                // this.checklist.checklistName[this.targetLocale] = await this.translatorService.translate(this.checklist.checklistName[this.sourceLocale], this.sourceLocale, this.targetLocale);

                const componentTree: ComponentInfo[] = await getComponentTree(this.$store.state.cl_uid);
                console.log('componentTree', componentTree);

                if (componentTree) {
                    // count components
                    for (const c of componentTree) {
                        await this.countComponent(c);
                    };

                    const progress = this.componentProgress;
                    this.initProgress(progress, this.totalComponents)
                    console.log('totalComponents', this.totalComponents);
                    // translate components
                    for (const c of componentTree) {
                        await this.translateComponent(c);
                        // stop after first component for debugging
                        // break; 
                    }
                }
            }
            console.log('translated checklist', this.checklist);
            var blob = new Blob([JSON.stringify(this.checklist, null, 2)], { type: "application/json" });
            // saveAs(blob, this.checklist.checklistName[this.sourceLocale] + '.json');
            this.translating = false;
        },
       
    },
    computed: {
        appLang: function () {
            return this.$store.state.lang
        },
        isTranslateButtonDisabled() {
            return this.translating || !this.sourceLocale || !this.sourceLocale || !this.checklist;
            // means u have neither name nor site  
        },
        currentLocale() {
            return this.$store.state.lang;
        }
    },

    components: {
        LanguageSelector
    }
}

